<div class="w-full max-w-4xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>{{ 'label_regular_fme_report_submit' | translate }}</h2>
        <div class="flex flex-col gap-4 mt-4 sm:mt-0 md:mt-4 w-full">
            <p class="m-0">
                {{ 'info_regular_fme_report_submit' | translate }}
            </p>
        </div>
    </div>
    @if (!isProcessingReport) {
        <div id="generate-report">
            <div class="prose prose-sm mb-2">
                <h3>{{ 'label_create_report' | translate }}</h3>
            </div>
            <p class="mb-2">
                {{ 'info_data_used_to_generate' | translate }}:
                <b>{{ lastMonthDate | date: 'MM.yyyy' }}</b>
            </p>
            <div class="flex gap-4">
                <button class="w-fit" mat-flat-button type="button" [color]="'primary'" (click)="onQueueGeneration()">
                    <mat-icon class="icon-size-5 mr-1" fontIcon="download" matPrefix></mat-icon>
                    {{ 'label_create_report' | translate }}
                </button>
            </div>
        </div>
    }
    @if (isProcessingReport) {
        <div id="currently-generating" class="mb-2">
            <div class="prose prose-sm mb-2">
                <h3>{{ 'label_processing' | translatePlural }}</h3>
            </div>
            <div class="mat-table-wrapper grid h-fit overflow-x-auto">
                <table matSort mat-table [dataSource]="messagesData" class="w-full">
                    <ng-container matColumnDef="id">
                        <th mat-sort-header="id" mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.id }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'label_title' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ getMessageTitle(element) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-sort-header="status" mat-header-cell *matHeaderCellDef>
                            {{ 'label_status' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.status == processingStatus.PROCESSING) {
                                <mat-icon class="relative animate-spin top-1 icon-size-5 text-blue-600" fontIcon="autorenew"></mat-icon>
                            }
                            @if (element.status == processingStatus.QUEUED) {
                                <mat-icon class="relative top-1 icon-size-5 text-gray-500" fontIcon="schedule"></mat-icon>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="created_at">
                        <th mat-sort-header="created_at" mat-header-cell *matHeaderCellDef>
                            {{ 'label_created_at' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span>{{ element.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="messagesColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: messagesColumns"></tr>
                </table>
            </div>
        </div>
    }
    <hr />
    <div id="report-list">
        <div class="prose prose-sm mb-2">
            <h3>{{ 'label_report' | translatePlural }}</h3>
        </div>
        <div class="mat-table-wrapper grid h-fit overflow-x-auto">
            <table matSort mat-table [dataSource]="reportsData" class="w-full">
                <ng-container matColumnDef="generatedAt">
                    <th mat-sort-header="generatedAt" mat-header-cell *matHeaderCellDef>
                        {{ 'label_date' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.generatedAt | date: 'dd.MM.YYYY kl. HH:mm' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="title">
                    <th mat-sort-header="title" mat-header-cell *matHeaderCellDef>
                        {{ 'label_title' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.title }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-icon class="icon-size-5 relative top-1" fontIcon="more_horiz"></mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex gap-2">
                            <button
                                mat-icon-button
                                class="p-2 text-sm w-fit"
                                matTooltipShowDelay="500"
                                [matTooltip]="'label_download_xml' | translate"
                                type="button"
                                (click)="onFetchXML(element)"
                            >
                                <mat-icon class="icon-size-5" fontIcon="download"></mat-icon>
                                XML
                            </button>
                            <button
                                mat-icon-button
                                class="p-2 text-sm w-fit"
                                matTooltipShowDelay="500"
                                [matTooltip]="'label_download_excel' | translate"
                                type="button"
                                (click)="onFetchExcel(element)"
                            >
                                <mat-icon class="icon-size-5" fontIcon="download"></mat-icon>
                                Excel
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="reportsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: reportsColumns"></tr>
                <tr class="mat-row" *matNoDataRow>
                    @if (reports != null) {
                        <div class="flex items-center justify-between">
                            <span>
                                <div class="mt-2 ml-2 font-medium text-secondary">
                                    {{ 'info_no_data_found' | translate: { count: 0 } }}
                                </div>
                            </span>
                        </div>
                    }
                </tr>
            </table>
            <mat-paginator
                #reportsPaginator
                class="justify-end"
                showFirstLastButtons
                [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 25, 100]"
            >
            </mat-paginator>
        </div>
    </div>
</div>
